/**
 * Blackwaxx&Co product recommendations: when the section has no metafield-driven products it asks Shopify for
 * complementary products (falling back to related) through the product recommendations endpoint, and swaps the cards in.
 * The section stays hidden if there is nothing to show.
 */
class BwRecommendations extends HTMLElement {
  async connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    for (const intent of ['complementary', 'related']) {
      try {
        const html = await fetch(`${url}&intent=${intent}`, { credentials: 'same-origin' }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('[data-bw-recommendations-grid]');
        if (grid && grid.children.length > 0) {
          this.querySelector('[data-bw-recommendations-grid]').innerHTML = grid.innerHTML;
          this.hidden = false;
          return;
        }
      } catch (_) {
        // try the next intent
      }
    }
  }
}

if (!customElements.get('bw-recommendations')) customElements.define('bw-recommendations', BwRecommendations);
